import { render, staticRenderFns } from "./DataFoto.vue?vue&type=template&id=875862bc&"
import script from "./DataFoto.vue?vue&type=script&lang=js&"
export * from "./DataFoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports